import React, { useState, useEffect } from 'react';
import Sidebar from './sidebar/Sidebar';
import './ChooseTemplate.css';
import downloadIcon from '../assets/download.svg';
import editIcon from '../assets/edit.svg';
import linktofileIcon from '../assets/linktofile.svg';
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import AddDocumentModal from './modals/CreateBlankModal';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Breadcrumbs from "../components/Breadcrumbs";

const SalesContracts = () => {
  const [expandedKeys, setExpandedKeys] = useState({});
  const [filters, setFilters] = useState({ global: { value: null, matchMode: 'contains' } });
  const [isFiltered, setIsFiltered] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isAddDocumentModalOpen, setIsAddDocumentModalOpen] = useState(false);
  const [selectedNodeKeys, setSelectedNodeKeys] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [first, setFirst] = useState(0);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
  const [showColumnOptions, setShowColumnOptions] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState({
    checkbox: true,
    name: true,
    clientName: true,
    dateCreated: true,
    status: true,
    modified: true,
    actions: true,
  });
  const [tempVisibleColumns, setTempVisibleColumns] = useState(visibleColumns);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    localStorage.setItem('clientFolderVisibleColumns', JSON.stringify(visibleColumns));
  }, [visibleColumns]);

  const nodes = [
    {
      key: '0',
      data: {
        name: 'Unknown',
        clientName: 'Unknown Client',
        createdDate: '2025-09-09',
        status: '',
        modified: '2025-09-09',
        url: '',
        isFolder: true,
      },
      children: [],
    },
    {
      key: '1',
      data: {
        name: 'Accenture',
        clientName: 'Accenture',
        createdDate: '2025-09-09',
        status: '',
        modified: '2025-09-09',
        url: '',
        isFolder: true,
      },
      children: [],
    },
    {
      key: '2',
      data: {
        name: 'CriCut',
        clientName: 'CriCut',
        createdDate: '2025-09-09',
        status: '',
        modified: '2025-09-09',
        url: '',
        isFolder: true,
      },
      children: [
        {
          key: '2-0',
          data: {
            name: '7.Change_Request(CR)',
            clientName: 'CriCut',
            createdDate: '2025-09-09',
            status: '',
            modified: '2025-09-09',
            url: '',
            isFolder: true,
          },
          children: [
            {
              key: '2-0-0',
              data: {
                name: 'ab.pdf',
                clientName: 'CriCut',
                createdDate: '2025-09-04',
                status: 'Active',
                statusColor: '#FF6B35',
                modified: '2025-09-04',
                url: 'https://example.com/ab.pdf',
                isFolder: false,
              },
            },
            {
              key: '2-0-1',
              data: {
                name: 'contract.pdf',
                clientName: 'CriCut',
                createdDate: '2025-09-04',
                status: 'Active',
                statusColor: '#FF6B35',
                modified: '2025-09-04',
                url: 'https://example.com/contract.pdf',
                isFolder: false,
              },
            },
          ],
        },
        {
          key: '2-1',
          data: {
            name: 'T1.pdf',
            clientName: 'CriCut',
            createdDate: '2025-09-02',
            status: 'Active',
            statusColor: '#FF6B35',
            modified: '2025-09-02',
            url: 'https://example.com/T1.pdf',
            isFolder: false,
          },
        },
        {
          key: '2-2',
          data: {
            name: 'T2.pdf',
            clientName: 'CriCut',
            createdDate: '2025-09-03',
            status: 'Active',
            statusColor: '#FF6B35',
            modified: '2025-09-03',
            url: 'https://example.com/T2.pdf',
            isFolder: false,
          },
        },
      ],
    },
  ];

  const flattenNodes = (nodes) => {
    let flat = [];
    nodes.forEach(node => {
      flat.push(node.data);
      if (node.children) {
        flat = flat.concat(flattenNodes(node.children));
      }
    });
    return flat;
  };

  const exportTableToCSV = () => {
    const flatData = flattenNodes(nodes);
    const headers = ['Contract Name', 'Client Name', 'Created Date', 'Status', 'Modified'];
    const rows = flatData.map(t => [t.name, t.clientName, t.createdDate, t.status, t.modified].join(','));
    const csvContent = `data:text/csv;charset=utf-8,${headers.join(',')}\n${rows.join('\n')}`;
    const encoded = encodeURI(csvContent);
    const a = document.createElement('a');
    a.href = encoded;
    a.download = 'client_folder_structure.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setShowDownloadMenu(false);
  };

  const exportTablePDF = () => {
    const doc = new jsPDF();
    doc.text('Client Folder Structure', 10, 10);
    autoTable(doc, {
      startY: 20,
      head: [['Contract Name', 'Client Name', 'Created Date', 'Status', 'Modified']],
      body: flattenNodes(nodes).map(t => [t.name, t.clientName, t.createdDate, t.status, t.modified]),
    });
    doc.save('client_folder_structure.pdf');
    setShowDownloadMenu(false);
  };

  const toggleColumn = (key) => {
    setTempVisibleColumns(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const handleColumnOptionsConfirm = () => {
    setVisibleColumns(tempVisibleColumns);
    setShowColumnOptions(false);
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      setSelectedNodeKeys(flattenNodes(nodes).map(node => node.isFolder ? null : node.name));
    } else {
      setSelectedNodeKeys([]);
    }
  };

  const handleTemplateSelect = (node) => {
    if (!node.data.isFolder) {
      const nodeKey = node.data.name;
      setSelectedNodeKeys(prev =>
        prev.includes(nodeKey) ? prev.filter(key => key !== nodeKey) : [...prev, nodeKey]
      );
      if (selectedNodeKeys.length + 1 < flattenNodes(nodes).filter(n => !n.isFolder).length && !selectedNodeKeys.includes(nodeKey)) {
        setSelectAll(false);
      }
    }
  };

  const handleViewTemplate = (data) => {
    setSelectedTemplate(data);
    setIsViewModalOpen(true);
  };

  const checkboxBody = (node) => (
    !node.data.isFolder && (
      <input
        type="checkbox"
        checked={selectedNodeKeys.includes(node.data.name)}
        onChange={() => handleTemplateSelect(node)}
        style={{ marginLeft: '25px' }}
      />
    )
  );

  const nameBody = (node) => (
    <div style={{ cursor: 'pointer', width: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
         onClick={() => !node.data.isFolder && window.open(node.data.url, '_blank')}>
      {node.data.isFolder ? '📁' : '📄'} {node.data.name}
    </div>
  );

  const clientNameBody = (node) => (
    <span style={{ display: 'block', textAlign: 'center', width: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
      {node.data.clientName}
    </span>
  );

  const createdDateBody = (node) => (
    <span style={{ display: 'block', textAlign: 'center', width: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
      {node.data.createdDate}
    </span>
  );

  const statusBody = (node) => (
    node.data.status ? (
      <span style={{ display: 'block', textAlign: 'center', color: 'white', width: '90px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                     backgroundColor: node.data.statusColor || '#FF6B35', padding: '2px 8px', borderRadius: '4px' }}>
        {node.data.status}
      </span>
    ) : null
  );

  const modifiedBody = (node) => (
    <span style={{ display: 'block', textAlign: 'center', width: '120px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
      {node.data.modified}
    </span>
  );

  const actionsBody = (node) => (
    !node.data.isFolder && (
      <div style={{ display: 'flex', gap: '5px', justifyContent: 'center', width: '130px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        <button className="action-btn download-btn" onClick={() => window.open(node.data.url, '_blank')}>
          <img src={downloadIcon} alt="Download" className="action-image1" style={{ filter: 'invert(45%) sepia(94%) saturate(2478%) hue-rotate(346deg) brightness(96%) contrast(97%)' }} />
        </button>
        <button className="action-btn edit-btn" onClick={() => handleViewTemplate(node.data)}>
          <img src={editIcon} alt="Edit" className="action-image1" style={{ filter: 'invert(45%) sepia(94%) saturate(2478%) hue-rotate(346deg) brightness(96%) contrast(97%)' }} />
        </button>
        <button title="Add Favourite" className="action-btn favorite-btn">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#FF6B35" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="action-image1">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
          </svg>
        </button>
        <button title="Trash" className="action-btn trash-btn">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="action-image1">
            <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
          </svg>
        </button>
      </div>
    )
  );

  return (
    <div className="choose-template-container">
      <Sidebar />
      <div className="main-content">
        <div className="card">
        <Breadcrumbs /><br/>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
            <h3 style={{ color: '#FF6B35', margin: 0 }} className="title">Sales Contracts</h3>
            <input
              type="text"
              placeholder="Search all columns..."
              value={filters.global.value || ""}
              onChange={(e) => setFilters({ global: { value: e.target.value, matchMode: 'contains' } })}
              style={{ padding: '8px', width: '300px', border: '1px solid #FF6B35', borderRadius: '4px' }}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '12px', margin: '20px 0' }}>
            <button
              onClick={() => { setShowColumnOptions(true); setTempVisibleColumns(visibleColumns); }}
              style={{ cursor: 'pointer', padding: '4px 12px', borderRadius: '6px', background: 'transparent', color: '#4A4A4A', border: '1px solid black', fontSize: '16px', fontWeight: 500 }}
            >
              ⚙ Column options
            </button>
            <div style={{ position: 'relative' }}>
              <button
                onClick={() => setShowDownloadMenu(!showDownloadMenu)}
                style={{ cursor: 'pointer', padding: '4px 12px', borderRadius: '6px', background: 'transparent', border: '1px solid black', color: '#4A4A4A', fontSize: '16px', fontWeight: 500, display: 'flex', alignItems: 'center', gap: '12px' }}
              >
                <img src={downloadIcon} alt="Download" style={{ width: '16px', height: '20px' }} /> Download
              </button>
              {showDownloadMenu && (
                <div className="Project-export-dropdown" style={{ position: 'absolute', right: 0, marginTop: '6px', borderRadius: '6px' }}>
                  <button onClick={exportTableToCSV} style={{ cursor: 'pointer', border: 'none', display: 'block', padding: '8px 12px', width: '120px', textAlign: 'left', background: 'none', color: '#4A4A4A' }}>Download CSV</button>
                  <button onClick={exportTablePDF} style={{ cursor: 'pointer', border: 'none', display: 'block', padding: '8px 12px', width: '120px', textAlign: 'left', background: 'none', color: '#4A4A4A' }}>Download PDF</button>
                </div>
              )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#4A4A4A', fontSize: '15px', fontWeight: 600 }}>
              Results: {flattenNodes(nodes).length === 0 ? 0 : first + 1}-{Math.min(first + rowsPerPage, flattenNodes(nodes).length)} of {flattenNodes(nodes).length}
              <select
                value={rowsPerPage}
                onChange={(e) => { setRowsPerPage(parseInt(e.target.value)); setFirst(0); }}
                style={{ paddingLeft: '10px', color: '#4A4A4A', fontSize: '16px', fontWeight: 500, backgroundColor: '#e5e7eb', width: '60px', height: '36px', borderRadius: '6px', border: 'none' }}
              >
                {[5, 10, 15, 20].map(n => (
                  <option key={n} value={n}>{n}</option>
                ))}
              </select>
            </div>
          </div>
          <div style={{ position: 'relative', overflowX: 'hidden' }}>
            <TreeTable
              value={nodes}
              expandedKeys={expandedKeys}
              onToggle={(e) => setExpandedKeys(e.value)}
              selectionMode="checkbox"
              selectionKeys={selectedNodeKeys}
              onSelectionChange={(e) => setSelectedNodeKeys(e.value)}
              paginator
              rows={rowsPerPage}
              first={first}
              onPage={(e) => setFirst(e.first)}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
              filters={filters}
              globalFilterFields={['name', 'clientName', 'createdDate', 'status', 'modified']}
              tableStyle={{ minWidth: 'auto' }}
              showGridlines
            >
             
              {visibleColumns.name && <Column field="name" header="Contract Name" body={nameBody} expander style={{ width: '200px', textAlign: 'center' }} sortable />}
              {visibleColumns.clientName && <Column field="clientName" header="Client Name" body={clientNameBody} style={{ width: '150px', textAlign: 'center' }} sortable />}
              {visibleColumns.dateCreated && <Column field="createdDate" header="Created Date" body={createdDateBody} style={{ width: '150px', textAlign: 'center' }} sortable />}
              {visibleColumns.status && <Column field="status" header="Status" body={statusBody} style={{ width: '90px', textAlign: 'center' }} sortable />}
              {visibleColumns.modified && <Column field="modified" header="Modified" body={modifiedBody} style={{ width: '120px', textAlign: 'center' }} sortable />}
              {visibleColumns.actions && <Column header="Actions" body={actionsBody} style={{ width: '130px', textAlign: 'center' }} />}
            </TreeTable>
          </div>
        </div>
        {showColumnOptions && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(6px)', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-end', zIndex: 1000 }}>
            <div style={{ width: '340px', background: '#fff', borderRadius: '8px', border: '1px solid #e5e7eb', overflow: 'hidden', marginTop: '100px', marginRight: '20px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 12px', fontWeight: 700, background: '#FF6B35', color: 'white' }}>
                <div>Column Options</div>
                <button onClick={() => setShowColumnOptions(false)} aria-label="Close" style={{ color: 'white', background: 'transparent', border: 'none', fontSize: '25px', cursor: 'pointer' }}>×</button>
              </div>
              <div style={{ marginTop: '-8px', fontSize: '12px', color: '#6B7280', padding: '0 12px 8px', borderBottom: '1px solid #e5e7eb' }}></div>
              <div style={{ maxHeight: '50vh', overflowY: 'auto', padding: '10px 12px' }}>
                {['checkbox', 'name', 'clientName', 'dateCreated', 'status', 'modified', 'actions'].map(key => (
                  <div key={key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #f3f4f6' }}>
                    <span style={{ fontSize: '14px', color: '#111827' }}>
                      {key === 'name' ? 'Contract Name' : key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}
                    </span>
                    <button onClick={() => toggleColumn(key)} aria-label={tempVisibleColumns[key] ? `Hide ${key}` : `Show ${key}`} style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                        {!tempVisibleColumns[key] && <line x1="2" y1="2" x2="18" y2="18" stroke="#000000" strokeWidth="3" />}
                      </svg>
                    </button>
                  </div>
                ))}
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', padding: '10px 12px', borderTop: '1px solid #e5e7eb' }}>
                <button onClick={() => setShowColumnOptions(false)} style={{ background: 'transparent', color: '#FF6B35', border: '1px solid #FF6B35', padding: '8px 14px', borderRadius: '6px' }}>Cancel</button>
                <button onClick={handleColumnOptionsConfirm} style={{ background: '#FF6B35', color: '#fff', border: '1px solid #FF6B35', padding: '8px 14px', borderRadius: '6px' }}>OK</button>
              </div>
            </div>
          </div>
        )}
        {isViewModalOpen && (
          <div className="modal-overlay" onClick={() => setIsViewModalOpen(false)}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <div className="modal-header">
                <h2>View Item</h2>
                <button className="close-btn" onClick={() => setIsViewModalOpen(false)}><span>×</span></button>
              </div>
              <div className="modal-body">
                <h3>{selectedTemplate?.name}</h3>
                <p><strong>Client Name:</strong> {selectedTemplate?.clientName}</p>
                <p><strong>Created Date:</strong> {selectedTemplate?.createdDate}</p>
                <p><strong>Status:</strong> {selectedTemplate?.status}</p>
                <p><strong>Modified:</strong> {selectedTemplate?.modified}</p>
              </div>
            </div>
          </div>
        )}
        <AddDocumentModal isOpen={isAddDocumentModalOpen} onClose={() => setIsAddDocumentModalOpen(false)} onSelectTemplate={() => {}} />
      </div>
    </div>
  );
};

export default SalesContracts;